<div *ngIf="!isShowResult">
  <form #f="ngForm" [formGroup]="mainFormGroup" (ngSubmit)="f.form.valid && forwardContract()" style="height: 520px;">
    <!-- header -->
    <h2 mat-dialog-title mat-dialog-draggable-title> {{'alert.forward_contract' | translate}}
      <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <!-- end header -->
    <mat-divider></mat-divider>
    <mat-dialog-content style="overflow-x: hidden;">
      <div class="row pt-3 pb-3">
        <div class="col-12">
          <!-- tim kiem nguoi dung -->
          <mat-form-field class="w-100">
            <mat-spinner *ngIf="isLoading" matSuffix diameter="20" style="position: relative;bottom: 20px;right: 40px;display: inline;"></mat-spinner>
            <input
              matInput
              type="text"
              formControlName="userSearch"
              [placeholder]="('form.list_user_forward_contract' | translate)"
              autocomplete="off"
              (keydown.enter)="$event.preventDefault()"
              [matAutocomplete]="userAutocomplete"
            />
            <mat-autocomplete #userAutocomplete="matAutocomplete" class="custom-autocomplete" classlist="custom-autocomplete"
                              (optionSelected)="onSelectUser($event)">
              <mat-option
                *ngFor="let option of filteredOptions"
                [value]="option.type === 'DEPARTMENT' ? option.departmentId : option.id"
                [disabled]="checkUserExist(option.type === 'DEPARTMENT' ? option.departmentId : option.id)"
              >
              <div *ngIf="option.type === 'DEPARTMENT'" class="row-icon department" [class.disabledNormal]="checkUserExist(option.type === 'DEPARTMENT' ? option.departmentId : option.id)"><span
                class="material-icons">apartment</span>{{ option.departmentCode }} - {{ option.departmentName }}</div>
              <div class="row-icon user"
                *ngIf="(option.type === 'DEPARTMENT' && option.representativeId) || option.type === 'USER'"
                [class.disabled]="!option.representativeIsActive && option.type === 'DEPARTMENT'">
                <span class="material-icons" *ngIf="option.type === 'USER'">person</span> {{option.name}} - {{option.email}}
                <span *ngIf="!option.representativeIsActive && option.type === 'DEPARTMENT'">{{"enterprise_contract.panel_document.table_users.representative_inactive" | translate }}</span>
                <span *ngIf="option.userPosition">- {{option.userPosition}}</span>
              </div>
              <div class="row-icon disabled user"
                *ngIf="!option.representativeId && option.type === 'DEPARTMENT'">
                {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
              </div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-12 pb-2" style="padding-right: 0.75rem;">
          <div class="d-flex flex-wrap flex-gap-chip" style="max-height: 200px;overflow-y: auto;">
            <div class="chip"
                 *ngFor="let user of mainFormGroup?.controls?.user?.value"
                 [title]="user.type === 'USER' ? user.username + '-' + user.fullName : user.departmentCode + '-' + user.departmentName"
            >
              <ng-container *ngIf="user.type === 'USER';else departmentType">
                {{ user.fullName }} - {{ user.email }} <span *ngIf="user.userPosition">- {{user.userPosition}}</span>
              </ng-container>
              <ng-template #departmentType>
                {{ user.departmentCode }} - {{ user.departmentName }}
              </ng-template>
              <span class="material-icons" (click)="removeUser(user)" > cancel </span>
            </div>
          </div>
        </div>
        <!-- Ghi chú -->
        <div class="col-12" style="padding-right: 0.75rem;">
          <mat-form-field class="w-100">
            <textarea formControlName="note"
                      type="text" matInput [placeholder]="'search_form.note' | translate" rows="3" name="note"
                      id="description" maxlength="500">
            </textarea>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <div style="position: sticky;top: 500px;">
      <mat-divider></mat-divider>
      <mat-dialog-actions class="mt-2" align="center">
        <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="onNoClick()" type="button" style="margin-bottom: 0px !important;" appTrackEvent="w.btn.chuyen_tiep_hd.huy_bo">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.cancel' | translate}}
        </button>
            <ng-container>
                <button mat-raised-button appTrackEvent="w.btn.chuyen_tiep_hd.chuyen_tiep" type="submit" [disabled]="f.form.invalid || mainFormGroup?.controls?.user?.value === null || mainFormGroup?.controls?.user?.value === undefined || mainFormGroup?.controls?.user?.value?.length === 0" color="primary">
                  <i *ngIf="!(f.form.invalid || mainFormGroup?.controls?.user?.value === null || mainFormGroup?.controls?.user?.value === undefined || mainFormGroup?.controls?.user?.value?.length === 0)" class="fa fa-paper-plane fa-fw vt-cursor-pointer mr-0" aria-hidden="true" style="color: #fff;font-size: 1rem;"
                  matTooltip="{{'enterprise_customer_management.buttons.forward_contract' | translate}}">
              </i>
              <i *ngIf="f.form.invalid || mainFormGroup?.controls?.user?.value === null || mainFormGroup?.controls?.user?.value === undefined || mainFormGroup?.controls?.user?.value?.length === 0" class="fa fa-paper-plane fa-fw vt-cursor-pointer mr-0" aria-hidden="true" style="font-size: 1rem;"
              matTooltip="{{'enterprise_customer_management.buttons.forward_contract' | translate}}">
          </i>
          {{'button.forward_contract' | translate}}
          </button>
            </ng-container>
        </mat-dialog-actions>
    </div>

  </form>

</div>
<div *ngIf="isShowResult">

    <!-- header -->
    <h2 mat-dialog-title mat-dialog-draggable-title> {{'alert.forward_contract_result' | translate}}
      <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <!-- end header -->
    <mat-divider></mat-divider>
    <mat-dialog-content>
      <div class="row pt-3 pb-3">
        <div class="col-12">
            <p>{{'alert.forward_contract_success_count' | translate}} <span style="font-weight: bold;">{{countSuccess}}</span></p>
            <p>{{'alert.forward_contract_error_count' | translate}} <span style="font-weight: bold;">{{countError}}</span></p>
        </div>

          <div class="col-12" *ngIf="listErrorUser.length > 0">
            <div class="mat-table-container">
                <mat-table [dataSource]="listErrorUser" class="mat-table-col-extra-sm">
                    <!-- Full name -->
                    <ng-container matColumnDef="fullName">
                        <mat-header-cell *matHeaderCellDef style="width: 50%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                            {{'headertable.name_or_department' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 50%;">
                            <span matTooltip="{{element.fullName}}" class="fix-width" style="margin-left: -5px;">
              {{element.fullName}}
            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Lỗi -->
                    <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef style="max-width: 50%;" class="mat-header-cell-center">
                            {{'headertable.error' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" matTooltip="{{'alert.forward_contract_error_notify' | translate}}" class="" style="max-width: 50%;">
                            <span class="fix-width">{{'alert.forward_contract_error_notify' | translate}}</span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
                    </mat-row>
                </mat-table>
            </div>
        </div>

      </div>
    </mat-dialog-content>
    <div>
      <mat-divider></mat-divider>
      <mat-dialog-actions class="mt-2" align="center">
        <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="onNoClick()" type="button" style="margin-bottom: 0px !important;" appTrackEvent="w.btn.chuyen_tiep_hd.huy_bo">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.close' | translate}}
        </button>
        </mat-dialog-actions>
    </div>


</div>
